import React, {useEffect, useState, useRef} from "react";

import styles from "./Navigation.module.scss";
import LazyLoad from "../../LazyLoad";

export default function Navigation() {
    const [sections, setSections] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const nav = useRef(null)

    useEffect(() => {
        setTimeout(() => setSections(document.querySelectorAll('section')), 1000)
    }, []);

    useEffect(() => {
        if (sections) {
            const activeItem = () => {
                Object.values(sections).map((item, index) => {
                    const itemRect = item.getBoundingClientRect();

                    const navItem = document.querySelectorAll(`.${styles.Main} li`)[index];

                    if (itemRect.top <= 10) {
                        if (!navItem.classList.contains('active')) {
                            navItem.classList.add('active');
                            setActiveIndex(index);
                        }

                        if (itemRect.top <= -(itemRect.height - 10)) {
                            navItem.classList.remove('active')
                        }
                    } else if (itemRect.bottom > window.innerHeight) {
                        navItem.classList.remove('active')
                    }

                    if (window.scrollY + navItem.getBoundingClientRect().top > sections[0].getBoundingClientRect().height) {
                        navItem.classList.add('dark')
                    } else {
                        navItem.classList.remove('dark')
                    }

                    return true;
                })
            };

            activeItem();

            window.addEventListener('scroll', () => {
                activeItem();
            })
        }
    }, [sections]);

    const handleAnchor = (section, index) => {
        if (index > activeIndex) {
            const indexes = Array.from(new Array(index), (x, i) => i + activeIndex)

            indexes.map(i => {
                const images = sections[i]?.querySelectorAll('img[data-src]');

                if (images) {
                    Object.values(images).map(img =>
                        LazyLoad(img)
                    );
                }

                return true;
            })
        }

        setTimeout(() => section.scrollIntoView({
            behavior: 'smooth'
        }), 500)
    };

    return (
        <nav className={styles.Main} ref={nav}>
            {
                sections ?
                    <ul>
                        {
                            Object.values(sections).map((section, index) => {
                                return (
                                    <li key={index} onClick={() => handleAnchor(section, index)}>
                                        <span>{section.querySelector('h2') ?
                                            section.querySelector('h2').innerText.split('. ')[1]
                                            : section.querySelector('h1').innerText
                                        }</span>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    : null
            }
        </nav>
    )
}
